<template>
  <div :class="isShowMe?'addOrder':'addOrder hide'">
     <div :class="isShowMe?'detailList-bg':'detailList-bg hide'"></div>
     
     <div :class="OrderType==1?'detailList':'detailList hide'">
			<div class="dl-top">
				<div class="dl-title fl">发布订单</div>
				<div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
			</div>
    
     <div class="main">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="订单详情" name="first">
            <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="4"><div class="grid-content bg-purple">任务：</div></el-col>
                <el-col :span="5"><div class="grid-content bg-purple">
                   <el-select value-key="value" v-model="OrderType" name="OrderType" size="small" @change="handleChangeOrderType">
                      <el-option key=1 label="直接解封" value=1></el-option>
                      <el-option key=2 label="预加解封" value=2></el-option>
                    </el-select>
                  </div></el-col>

               <el-col :span="5"><div class="grid-content bg-purple">
                  <el-select v-model="Province" name="Province"  size="small" value-key="value" >
                     <el-option v-for="item in Provinces" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                 </div></el-col>
                    <el-col :span="5"><div class="grid-content bg-purple">
                      <el-select v-model="IsSms" size="small" value-key="value">
                        <el-option key=0 label="不需要短信" value=0></el-option>
                        <el-option key=1 label="需要短信" value=1></el-option>
                    </el-select>
                  </div></el-col>
            </el-row>

            <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="4"><div class="grid-content bg-purple">保证金：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number label="保证金" v-model="EnSure" name="EnSure" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
            </el-row>
             <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="4"><div class="grid-content bg-purple">订单价格：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number label="订单价格" v-model="Price" name="Price" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
            </el-row>

             <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="4"><div class="grid-content bg-purple">解封微信号：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input size="small" v-model="UnlockWx" placeholder="解封微信号"></el-input></div></el-col>
            </el-row>
        </el-tab-pane>
        <el-tab-pane label="备忘" name="second"><el-input size="small"  type="textarea" rows="6" v-model="Comment" placeholder="可用于记录订单来源，客户联系方式，实际价格等，仅发单者可见……"></el-input></el-tab-pane>
      </el-tabs>
     </div>
		      <div class="dl-footer">
             <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="4"><div class="grid-content bg-purple">联系QQ：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input size="small"  v-model="QQ" ></el-input></div></el-col>
              <el-col :span="15"><div class="grid-content bg-purple"><span class="fr"><el-button type="primary" size="small" @click="addOrder">发布订单</el-button></span></div></el-col>
            </el-row>
          </div>
		</div>
    

      <!-- 预加解封 -->
     <div :class="OrderType==2?'detailList1':'detailList1 hide'">
			<div class="dl-top">
				<div class="dl-title fl">发布订单</div>
				<div class="dl-close fr"><img @click="closeWindow" src="../assets/close.png" ></div>
			</div>
    
     <div class="main">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="订单详情" name="first">
            <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">任务：</div></el-col>
                <el-col :span="5"><div class="grid-content bg-purple">
                   <el-select value-key="value" v-model="OrderType" name="OrderType" size="small" @change="handleChangeOrderType">
                      <el-option key=1 label="直接解封" value=1></el-option>
                      <el-option key=2 label="预加解封" value=2></el-option>
                    </el-select>
                  </div></el-col>

               <el-col :span="5"><div class="grid-content bg-purple">
                  <el-select value-key="value" v-model="LimitType" name="LimitType" size="small" >
                      <el-option key=1 label="单人订单" value=1></el-option>
                      <el-option key=2 label="团队订单" value=2></el-option>
                    </el-select>
                </div></el-col>
            </el-row>

            <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">账号数量：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number label="账号数量" v-model="OrderNum" name="OrderNum" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
               <el-col :span="5"><div class="grid-content bg-purple">个</div></el-col>
            </el-row>

            <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">单价：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number label="单价" v-model="Price" name="Price" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
               <el-col :span="5"><div class="grid-content bg-purple">元</div></el-col>
            </el-row>

            <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">保证金：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number @change="handleChangeMoney" label="保证金" v-model="EnSure" name="EnSure" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
               <el-col :span="5"><div class="grid-content bg-purple">元</div></el-col>
            </el-row>

             <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">保费：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input-number @change="handleChangeMoney" label="保费" v-model="Premium" name="Premium" size="small" controls-position="right" :controls="false"></el-input-number></div></el-col>
               <el-col :span="5"><div class="grid-content bg-purple">元</div></el-col>
            </el-row>

             <el-row :gutter="20" align="top"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">解封微信号：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple"><el-input size="small"  type="textarea"  rows="4" v-model="UnlockWx" placeholder="请输入需要预加解封的微信号"></el-input></div></el-col>
            </el-row>

            <el-row :gutter="20" align="top"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">微信群二维码：</div></el-col>
              <el-col :span="19"><div class="grid-content bg-purple">
                  <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    :action="domain"
                    accept="image/jpeg,image/gif,image/png,image/bmp"
                    :headers="myHeader"
                    :http-request="uploadFile"
                    :on-change="changeFile"
                    :show-file-list="false"
                    :auto-upload="false"
                    list-type="picture"
                    :multiple="false">
                    <img v-if="BinaryImg" :src="BinaryImg" class="avatar" >
                    <i v-else class="el-icon-plus avatar-uploader-icon"><span>选择图片</span></i>
                  </el-upload> 
                  <!-- <div class="upload-button"> <el-button type="primary" size="small" @click="submitUpload()" >上传</el-button></div> -->
                  <div class="clear"></div>
              <span class="tips">必须发布微信群二维码，禁止广告以及欺骗行为，否则官方有权冻结账号与资金</span></div>
              </el-col>
            </el-row>

            <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">好友验证内容：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input size="small"  v-model="Validate" ></el-input></div></el-col>
            </el-row>
           
        </el-tab-pane>
        <el-tab-pane label="备忘" name="second"><el-input size="small"  type="textarea" rows="6" v-model="Comment" placeholder="可用于记录订单来源，客户联系方式，实际价格等，仅发单者可见……"></el-input></el-tab-pane>
      </el-tabs>
     </div>
		      <div class="dl-footer">
             <el-row :gutter="20" align="middle"  type="flex" class="mb20"> 
              <el-col :span="5"><div class="grid-content bg-purple">联系QQ：</div></el-col>
              <el-col :span="5"><div class="grid-content bg-purple"><el-input size="small"  v-model="QQ" ></el-input></div></el-col>
              <el-col :span="14"><div class="grid-content bg-purple"><span class="fr"><el-button type="primary" size="small" @click="submitUpload">发布订单</el-button></span></div></el-col>
            </el-row>
          </div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'addOrder',
  props:["isShow"],
  data () {
    return {
       Provinces:[{id:"",name:"不限地区"},{id:"北京市",name:"限北京市"},{id:"天津市",name:"限天津市"},{id:"上海市",name:"限上海市"},{id:"重庆省",name:"限重庆省"},{id:"河北省",name:"限河北省"},{id:"山西省",name:"限山西省"},{id:"辽宁省",name:"限辽宁省"},{id:"吉林省",name:"限吉林省"},{id:"黑龙江省",name:"限黑龙江省"},{id:"江苏省",name:"限江苏省"},{id:"浙江省",name:"限浙江省"},{id:"安徽省",name:"限安徽省"},{id:"福建省",name:"限福建省"},{id:"江西省",name:"限江西省"},{id:"山东省",name:"限山东省"},{id:"河南省",name:"限河南省"},{id:"湖北省",name:"限湖北省"},{id:"湖南省",name:"限湖南省"},{id:"广东省",name:"限广东省"},{id:"海南省",name:"限海南省"},{id:"四川省",name:"限四川省"},{id:"贵州省",name:"限贵州省"},{id:"云南省",name:"限云南省"},{id:"陕西省",name:"限陕西省"},{id:"甘肃省",name:"限甘肃省"},{id:"青海省",name:"限青海省"},{id:"广西省",name:"限广西省"},{id:"内蒙古",name:"限内蒙古"},{id:"西藏",name:"限西藏"},{id:"新疆",name:"限新疆"}],
       Province:"",
       activeName: 'first',
       OrderType:'1',
       IsSms:'0',
       LimitType:'1',
       EnSure:0,
       Price:40,
       OrderNum:30,
       Premium:0,
       UnlockWx:'',
       Comment:'',
       imageUrl: '',
       Validate:'解封',
       BinaryImg:'',
       fileUid:0,
       isShowMe:this.isShow,
       QQ:JSON.parse(this.common.GetlocalStorage("UnLockUserData")).QQ
    }
  },
  computed:{
     domain(){
       return this.$store.getters.domain+'ImgBase64Upload1';
     },
     myHeader(){
       return {"content-type":"multipart/form-data"}
     },
     loading(){
       return this.$store.getters.loadingPara;
     }
  },
  watch: {
    isShow(val) {
      this.isShowMe = val;
    },
    isShowMe(val){
      this.$emit("on-close",val);
    }
  },
  methods: {
    handleClick(tab, event) {
        //console.log(tab, event);
    },
    closeWindow(){
			this.isShowMe=false;
    },
    handleChangeMoney(value){
      this.EnSure=value;
      this.Premium=value;
    },
    handleChangeOrderType(value)
    {
       if(value==1)
          this.Price=40;
        else
          this.Price=100;
    },
    addOrder(){
      const self = this;
      if(this.OrderType==1){
        //发布直接解封
        if(this.EnSure=="" && this.EnSure!=0)
            this.$message({ message: '请输入保证金', type: 'warning'});
        else if(this.Price=="" && this.Price!=0)
            this.$message({ message: '请输入订单价格', type: 'warning'});
        else if(this.UnlockWx=="")
            this.$message({ message: '请输入解封微信号', type: 'warning'});
        else if(this.QQ=="")
            this.$message({ message: '请输入联系QQ', type: 'warning'});
        else{
            var msg="请输入您的支付密码";
            this.$prompt(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPlaceholder:'请输入您的支付密码',
            inputType:'password',
            inputPattern: /\S/,
            inputErrorMessage: '请输入您的支付密码'
            }).then(({ value }) => {
               self.LevelOrderAdd1Ajax(value,self);
            }).catch(() => {  });
        }
      }else{
        //发布预加解封
        if(this.EnSure==this.Premium){
              var msg="请输入您的支付密码";
              this.$prompt(msg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPlaceholder:'请输入您的支付密码',
              inputType:'password',
              inputPattern: /\S/,
              inputErrorMessage: '请输入您的支付密码'
              }).then(({ value }) => {
                self.LevelOrderAdd2Ajax(value,self);
              }).catch(() => {  });
        }else{
          this.$message({ message: '保证金必须和保费相等', type: 'warning'});  
        }
      }
    },
    LevelOrderAdd1Ajax(paypass,obj){
        const self = obj;
        const loading = this.$loading(this.loading);
        var data= self.common.GetlocalStorage("UnLockUserData");
        paypass=self.http.get_pwd_hash(paypass,JSON.parse(data).uid);
        var json={"Price":self.Price,"Ensure":self.EnSure,"Comment":self.Comment,"Province":self.Province,"PayPass":paypass,"IsApp":0,"IsSmsSend":self.IsSms,"QQ":self.QQ,"UnlockWx":self.UnlockWx }
        self.http.ajaxPost('LevelOrderAddPost',json,"",function(data){
             loading.close();
             if(data.ReturnCode==1){
              self.$emit("on-success-add",1);
              self.closeWindow();
              self.Price=40;
              self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
             }else if(data.ReturnCode==-3){
               self.$message({duration:1000, message: data.Message, type: 'warning',onClose:function(){ self.addOrder(); } });
             }else{
               self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
             }
        },function(res){ self.$alert(res, '错误', {confirmButtonText: '确定'});});
    },
    LevelOrderAdd2Ajax(paypass,obj){
        const self = obj;
        var data= self.common.GetlocalStorage("UnLockUserData");
        paypass=self.http.get_pwd_hash(paypass,JSON.parse(data).uid);
        const loading = this.$loading(this.loading);
        var json={"Price":self.Price,"Ensure":self.EnSure,"Comment":self.Comment,"LimitType":self.LimitType,"PayPass":paypass,"IsApp":0,"OrderNum":self.OrderNum,"QQ":self.QQ,"UnlockWx":self.UnlockWx,"Premium":self.Premium,"EwmUrl":self.imageUrl,"Validate":self.Validate }
       
        self.http.ajaxPost('LevelOrderAdd1',json,"",function(data){
             loading.close();
             if(data.ReturnCode==1){
              self.$emit("on-success-add",2);
              self.closeWindow();
              self.Price=100;
              self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
             }else if(data.ReturnCode==-3){
               self.$message({duration:1000, message: data.Message, type: 'warning',onClose:function(){ self.addOrder(); } });
             }else{
               self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
             }
        },function(res){ self.$alert(res, '错误', {confirmButtonText: '确定'});});
    },
    checkUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isGIF = file.type === 'image/gif';
        const isPNG = file.type === 'image/png';
        const isBMP = file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isGIF && !isPNG && !isBMP) {
            this.$alert('上传图片必须是JPG/GIF/PNG/BMP 格式!', '提示', {confirmButtonText: '确定'});
        }else if(!isLt2M) {
            this.$alert('上传图片大小不能超过 2MB!', '提示', {confirmButtonText: '确定'});
        }
        return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    changeFile(file,fileList){
      this.fileUid=file.uid;
      this.BinaryImg=file.url;
    },
    submitUpload() {
       //发布预加解封
      if(this.EnSure=="" && this.EnSure!=0)
          this.$message({ message: '请输入保证金', type: 'warning'});
      if(this.EnSure<0)
          this.$message({ message: '保证金输入错误', type: 'warning'});   
      else if(this.Price=="" && this.Price!=0)
          this.$message({ message: '请输入订单价格', type: 'warning'});
      else if(this.Price<10)
          this.$message({ message: '订单价格不能小于10元', type: 'warning'});
      else if(this.UnlockWx=="")
          this.$message({ message: '请输入解封微信号', type: 'warning'});
      else if(this.QQ=="")
          this.$message({ message: '请输入联系QQ', type: 'warning'});
      else if(this.OrderNum =="" && this.OrderNum!=0)
          this.$message({ message: '请输入账号数量', type: 'warning'});
      else if(this.OrderNum<=0 || this.OrderNum.toString().indexOf('.')!=-1)
          this.$message({ message: '账号数量输入错误', type: 'warning'});
      else if(this.OrderNum>30)
          this.$message({ message: '账号数量不能大于30个', type: 'warning'});
      else if(this.Premium =="" && this.Premium!=0)
          this.$message({ message: '请输入保费', type: 'warning'});
      else if(this.Premium<0)
          this.$message({ message: '保费输入错误', type: 'warning'});
      else if(this.Validate =="")
          this.$message({ message: '请输入好友验证内容', type: 'warning'});  
      else{
          if(this.BinaryImg==''){
            this.$message({ message: '请选择一张图片', type: 'warning'}); 
          }else{
            this.$refs.upload.submit();
          }
      }
    },
    uploadFile: function (fileObj) {     //上传图片成功后发布订单
       const loading = this.$loading(this.loading);
       var file=fileObj.file;
       if(file.uid==this.fileUid){
        var b=this.checkUpload(file);
        if(b){
            const self = this;
            var reader = new FileReader();
            reader.onload = function(event) {
            // event.target.result 即为图片的Base64编码字符串
            var imsJson = [{
              "value": event.target.result,
              "name":'111'
            }];
            var json={"file":imsJson }
            self.http.ajaxPost('ImgBase64Upload',json,"",function(data){
                loading.close();
                if(data.ReturnCode == 1){
                  self.imageUrl=data.Result[0];
                  //self.$alert('上传成功', '温馨提示', {confirmButtonText: '确定'});
                  self.addOrder();
                }else{
                  self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
                }
            },function(res){ self.$alert(res, '错误', {confirmButtonText: '确定'});});
          }
          reader.readAsDataURL(file);
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .detailList-bg{position:fixed;width:100%;height:100%;bottom:0;background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:99; }
	.detailList{width:770px;height:470px;position: fixed; top:50%; left:50%; margin-left:-385px; margin-top:-235px;  z-index:999; background: #fff; }
	.detailList .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList .dl-close img{ cursor: pointer;}
  .detailList .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:710px; padding:0 30px;}
  .detailList .main{ padding:0 30px; font-size:16px; color:#444;}

  .detailList1{width:770px;height:800px;position: fixed; top:50%; left:50%; margin-left:-385px; margin-top:-400px;  z-index:999; background: #fff; }
	.detailList1 .dl-top{background: #f0f0f0; height:60px; line-height: 60px;}
	.detailList1 .dl-title{ font-size:20px; color:#444; margin-left:45px;}
	.detailList1 .dl-close{ margin-right:25px; margin-top:8px;}
	.detailList1 .dl-close img{ cursor: pointer;}
  .detailList1 .dl-footer{height:60px; line-height:60px; font-size:16px; color:#444; background: #eee; position:absolute; bottom:0; width:710px; padding:0 30px;}
  .detailList1 .main{ padding:0 30px; font-size:16px; color:#444;}

  .mb20{margin-bottom:20px;}
  .tips{font-size:14px; color:#999; padding-top:10px; display:block; }
  .upload-button{ margin-left:20px; margin-top:98px; float: left;}

  .avatar-uploader{cursor:pointer;overflow:hidden; float: left; vertical-align: bottom;}
  .avatar-uploader-icon:hover {border-color:#409EFF;}
  .avatar-uploader-icon {font-size:38px;color:#8c939d;width:128px;height:98px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px; padding-top:30px;}
  .avatar-uploader-icon span{ font-size:16px; display: block; padding-top:10px;}
  .avatar{ max-width: 128px; max-height:128px;}
 

</style>



// WEBPACK FOOTER //
// src/components/addOrder.vue